import React from "react";
import { Container } from "reactstrap";

import IFrameList from "../NetworkProviders";
import Network    from "~/services/networks";

const Offers = ({})=> {

  return (
    <Container className="offers-page p-t-20">
      <h1 className="main-title"> Offers </h1>
      <IFrameList type={Network.type.OFFER_LIST} />
    </Container>
  );
};

export default Offers;
